import MessagingBroadcast from './MessagingBroadcast';

export default MessagingBroadcast;
